// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"386":"d8143863","509":"226a410b","813":"cd6b5ac8","911":"60572404","949":"e1702c26"}[chunkId] + ".chunk.js";
};